module.exports = __webpack_public_path__ + "static/media/whatsapp-orange.3bb50989.svg";